<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalMap"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-width"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div style="text-transform: uppercase" class="card_title_1">
              <span>{{ dataDetail.metricName }}</span>
            </div>
            <!-- <div class="card_title_2">Last Update: {{ lastUpdate }}</div> -->
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div
            style="display: flex; justify-content: space-between"
            class="m-t-10 m-b-10 mobile-header-select"
          >
            <div class="card-header-right">
              <div>
                <button
                  v-if="
                    titleSub !== '' &&
                    dataDetail.metricId !==
                      'DISTRIBUTION_NUMBER_OF_INCIDENTS' &&
                    dataDetail.metricId !==
                      'DISTRIBUTION_NUMBER_OF_FATALITIES' &&
                    dataDetail.metricId !== 'DISTRIBUTION_UNSAFE_ACT' &&
                    dataDetail.metricId !== 'DISTRIBUTION_UNSAFE_CONDITION' &&
                    dataDetail.metricId !== 'DISTRIBUTION_NEAR_MISS'
                  "
                  @click="removeData"
                  class="m-r-15 border-period-left border-period-right btn btn-info"
                  type="button"
                >
                  {{ titleSub }}
                  <i
                    style="color: white !important"
                    class="fa fa-close m-l-15"
                  ></i>
                </button>
                <button
                  v-if="!isSaldo"
                  class="border-period-left border-period-right btn btn-info btn-disable btn-square"
                  :class="{ 'btn-info color-active': activeClass }"
                  type="button"
                >
                  By Unit
                </button>
                <button
                  v-if="isSaldo"
                  @click="unit"
                  class="border-period-left btn btn-disable btn-square"
                  :class="{ 'btn-info color-active': activeClass }"
                  type="button"
                >
                  By Unit
                </button>
                <button
                  v-if="isSaldo"
                  @click="material"
                  :class="{ 'btn-info color-active': isActiveMaterial }"
                  class="border-period-right btn btn-square btn-disable m-r-10"
                  type="button"
                >
                  By Material
                </button>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex">
                <div>
                  <input
                    class="m-r-5 form-check-input custom_checkbox_compen"
                    type="checkbox"
                    id="isCheckedHigh"
                    value="isCheckedHigh"
                    v-model="isCheckedHigh"
                  />
                </div>
                <div
                  id="isCheckedHigh"
                  style="align-self: center"
                  class="custom_checkbox_distribution"
                >
                  {{
                    isSaldo === true
                      ? "Above and Equals Safety Stock"
                      : "Above and Equals Than Target"
                  }}
                </div>
              </div>
              <div class="d-flex">
                <div>
                  <input
                    class="m-r-5 form-check-input custom_checkbox_dist"
                    type="checkbox"
                    disabled
                    v-model="isCheckedLow"
                  />
                </div>
                <div
                  style="align-self: center"
                  class="custom_checkbox_distribution"
                >
                  {{
                    isSaldo === true
                      ? "Lower Than Safety Stock"
                      : "Lower Than Target"
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isLoading"
            class="row m-t-15 table-responsive signal-table"
          >
            <table class="table table-hover">
              <thead style="--bs-table-bg: #e8e8e8; color: #999999">
                <tr v-if="isSaldo">
                  <th class="font-gray">
                    {{ !isActiveUnit ? "Unit" : "Material" }}
                  </th>
                  <th class="font-gray">
                    {{ isActiveUnit ? "Unit" : "Material" }}
                  </th>
                  <th v-if="isUnitSaldo && isSaldo"></th>
                  <th v-if="isUnitSaldo && isSaldo"></th>
                </tr>
                <tr v-else>
                  <th class="font-gray">Unit</th>
                  <th class="font-gray" style="text-transform: capitalize">
                    {{ dataDetail.metricName }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in dataTable" :key="index">
                  <tr>
                    <td
                      :style="
                        item.items.length !== 0 ? 'height:90px !important' : ''
                      "
                      style="white-space: nowrap"
                      @click="detail(item)"
                      class="d-flex align-items-center"
                    >
                      <div
                        class="m-r-5"
                        style="
                          width: 10px; /* Adjust size of the dot */
                          height: 10px; /* Same as width to ensure a perfect circle */
                          background-color: #ff9900; /* Replace with your desired color */
                          border-radius: 50%; /* Makes the div circular */
                        "
                        :style="
                          item.status === 'LOW'
                            ? 'background-color: #ff9900;'
                            : 'background-color:#16C7F9'
                        "
                      ></div>
                      {{ item.name }}
                    </td>
                    <!-- <td v-if="item.items.length === 0"></td>
                    <td v-if="item.items.length === 0"></td>
                    <td v-if="item.items.length === 0"></td> -->
                    <!-- <td
                      v-if="item.items.length === 0 && isUnitSaldo && isSaldo"
                    ></td>
                    <td
                      v-if="item.items.length === 0 && isUnitSaldo && isSaldo"
                    ></td> -->
                    <td>
                      <div style="display: flex">
                        <div
                          v-show="item.items.length > 0"
                          v-for="(i, idx) in item.items"
                          :key="idx"
                          class="m-r-10"
                          style="
                            white-space: nowrap;
                            padding: 5px 15px 5px 15px;
                            color: white;
                            border-radius: 10px;
                          "
                          :style="
                            i.status === 'LOW'
                              ? 'background-color: #ff9900;'
                              : 'background-color:#16C7F9'
                          "
                        >
                          <span
                            :style="isSaldo !== true ? 'display:none' : ''"
                            v-if="isSaldo === true"
                            >{{ i.name !== null ? i.name : i.value }}</span
                          ><br
                            :style="isSaldo !== true ? 'display:none' : ''"
                          /><span
                            >{{ isSaldo === true ? "Stock :" : "" }}
                            {{ i.value }}</span
                          >
                        </div>
                      </div>
                    </td>
                    <!-- <template v-for="(i, idx) in item.items" :key="idx">
                    </template> -->
                  </tr>
                  <tr
                    v-for="(item_child, index_child) in item.children"
                    :key="index_child"
                    v-show="
                      selectedId === item.children &&
                      dataDetail.metricId !==
                        'DISTRIBUTION_NUMBER_OF_INCIDENTS' &&
                      dataDetail.metricId !==
                        'DISTRIBUTION_NUMBER_OF_FATALITIES' &&
                      dataDetail.metricId !== 'DISTRIBUTION_UNSAFE_ACT' &&
                      dataDetail.metricId !== 'DISTRIBUTION_UNSAFE_CONDITION' &&
                      dataDetail.metricId !== 'DISTRIBUTION_NEAR_MISS'
                    "
                  >
                    <td class="m-l-20 d-flex align-items-center">
                      <div
                        class="m-r-5"
                        style="
                          width: 10px; /* Adjust size of the dot */
                          height: 10px; /* Same as width to ensure a perfect circle */
                          border-radius: 50%; /* Makes the div circular */
                        "
                        :style="
                          item_child.status === 'LOW'
                            ? 'background-color: #ff9900;'
                            : 'background-color:#16C7F9'
                        "
                      ></div>
                      {{ item_child.name }}
                    </td>
                    <td
                      v-for="(i_child, idx_child) in item_child.items"
                      :key="idx_child"
                    >
                      <span
                        v-if="i_child.value !== null"
                        class="m-r-5"
                        style="
                          padding: 5px 15px 5px 15px;
                          color: white;
                          border-radius: 10px;
                        "
                        :style="
                          item_child.status === 'LOW'
                            ? 'background-color: #ff9900;'
                            : 'background-color:#16C7F9'
                        "
                      >
                        {{ i_child.value }}
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
              <!-- <tbody class="m-t-10">
                <tr v-for="(item, id) in dataTable" :key="id" class="subheader">
                  <td class="d-flex align-items-center">
                    <div
                      class="m-r-5"
                      style="
                        width: 10px; /* Adjust size of the dot */
                        height: 10px; /* Same as width to ensure a perfect circle */
                        background-color: #ff9900; /* Replace with your desired color */
                        border-radius: 50%; /* Makes the div circular */
                      "
                    ></div>
                    {{ item.name }}
                  </td>
                  <td>
                    <span
                      class="m-r-5"
                      style="
                        background-color: #ff9900;
                        padding: 1%;
                        color: white;
                        border-radius: 10px;
                      "
                    >
                      MCB
                    </span>
                    <span
                      style="
                        background-color: #ff9900;
                        padding: 1%;
                        color: white;
                        border-radius: 10px;
                      "
                    >
                      Trafo Distribusi
                    </span>
                  </td>
                </tr>
              </tbody> -->
            </table>
          </div>
          <div class="text-lg-center m-t-15 m-b-15" v-else>
            <div class="spinner"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DistributionService from "@/services/distribution/distribution";
const apiDistribution = DistributionService.build();
export default {
  components: {},
  props: ["showModal", "dataDetail", "titleNetwork"],
  data() {
    return {
      isLoading: true,
      isActiveMaterial: false,
      isCheckedHigh: false,
      isCheckedLow: false,
      isUnitSaldo: false,
      isSaldo: false,
      activeClass: true,
      isActiveUnit: false,
      tooltipIndex: null,
      tooltipX: 0,
      tooltipY: 0,
      dataTable: [],
      modalMap: {
        show: false,
        load: false,
      },
      lastUpdate: "",
      modal: null,
      series: [],
      chartOptions: {},
      selectedId: null,
      titleSub: "",
      isTooltip: false,
      dataTemp: [],
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalMap);
  },
  methods: {
    removeData() {
      this.titleSub = "";
      this.selectedId = null;
    },
    detail(x) {
      let data = this.dataDetail;
      if (
        this.titleSub !== x.name &&
        !data.metricId.includes("DISTRIBUTION_SUSUT")
      ) {
        this.titleSub = x.name;
        this.selectedId = x.children;
      } else {
        this.titleSub = "";
        this.selectedId = null;
      }
    },
    async getDataDetail() {
      this.isLoading = true;
      let data = this.dataDetail;
      let parts = data.cardId.split("@");
      this.isSaldo =
        data.metricId === "DISTRIBUTION_SALDO_STOK_MATERIAL" ? true : false;
      // this.isUnitSaldo =
      //   data.metricId === "DISTRIBUTION_SALDO_STOK_MATERIAL" ? true : false;
      let param = Object.assign({
        metricId: data.metricId,
        instance: parts[0],
        groupBy: this.isActiveUnit ? "material" : "instance",
        status: !this.isCheckedHigh ? "" : "NORMAL",
      });
      const res = await apiDistribution.getDataDistributionDetail(param);
      this.lastUpdate = res.data.lastUpdate;
      this.dataTable = res.data.data;
      this.dataTemp = res.data.data;
      this.isLoading = false;
    },
    unit() {
      this.titleSub = "";
      this.activeClass = true;
      this.isActiveUnit = false;
      this.isActiveMaterial = false;
      this.isUnitSaldo = true;
      this.getDataDetail();
    },
    material() {
      this.titleSub = "";
      this.activeClass = false;
      this.isActiveMaterial = true;
      this.isActiveUnit = true;
      this.isUnitSaldo = true;
      this.getDataDetail();
    },
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    detailChart() {
      this.titleNetworks = "Kalimantan Barat";
      this.modalMap.show = true;
    },
    closeModal() {
      this.activeClass = true;
      this.isActiveMaterial = false;
      this.$emit("closeModal", false);
    },
  },

  watch: {
    isCheckedHigh() {
      if (this.isCheckedHigh) {
        this.isCheckedHigh = true;
        // const filter = this.dataTemp.filter((item) => item.status !== "LOW");
        // this.dataTable = filter;
        this.getDataDetail();
      } else {
        this.isCheckedHigh = false;
        // this.isCheckedLow = true;
        this.getDataDetail();
        // this.dataTable = !this.isCheckedLow ? this.dataTemp : this.dataTable;
      }
    },
    isCheckedLow() {
      if (this.isCheckedLow) {
        this.isCheckedHigh = false;
        const filter = this.dataTemp.filter((item) => item.status === "LOW");
        this.dataTable = filter;
      } else {
        this.dataTable = !this.isCheckedHigh ? this.dataTemp : this.dataTable;
      }
    },
    async showModal() {
      if (this.showModal) {
        this.isCheckedHigh = false;
        this.isActiveUnit = false;
        this.isUnitSaldo = true;
        this.getDataDetail();
        this.titleSub = "";
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom_header {
  padding: 1rem 1rem 0rem 1rem;
  border-bottom: unset;

  .custom_header_content {
    width: 100%;
    position: relative;

    .close_btn {
      position: absolute;
      right: 0;
      z-index: 999;
    }

    .tahun_text {
      font-size: 20px;
      font-weight: 400;
      line-height: 23px;
    }

    .judul_text {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
    }
  }
}

.custom-modal-width {
  max-width: 500px;
  width: 100%;
}

.tabs {
  color: #838383;
  font-size: 14px;
  padding: 5px;
  cursor: pointer;
}

.tabs_active {
  color: #00a3e9;
  border-bottom: 3px solid #00a3e9;
}

.custom_pb {
  background: unset !important;
  height: 8px;
}
.color-active {
  color: #fff !important;
}
.btn-disable {
  color: #999999;
  background-color: #e9e9e9;
}
.border-period-left {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.border-period-right {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.font-gray {
  color: #999999 !important;
}
.btn-small {
  padding: 0.4rem 1rem;
  font-size: 11px;
}
</style>
